import { render, staticRenderFns } from "./AvatarWrapperSmall.vue?vue&type=template&id=c4c6a4aa&scoped=true&"
import script from "./AvatarWrapperSmall.vue?vue&type=script&lang=js&"
export * from "./AvatarWrapperSmall.vue?vue&type=script&lang=js&"
import style0 from "./AvatarWrapperSmall.vue?vue&type=style&index=0&id=c4c6a4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c6a4aa",
  null
  
)

export default component.exports